/* global axios */
import ApiClient from './ApiClient';

// SICARG MOD 6 v2 — Descarte individual de menciones en el Panel del agente.
class MentionsAPI extends ApiClient {
  constructor() {
    super('mentions', { accountScoped: true });
  }

  dismiss(id) {
    return axios.post(`${this.url}/${id}/dismiss`);
  }
}

export default new MentionsAPI();
